'use client'

import BookDemoModal from '@/components/RevampedLanding/BookDemo'
import HandsOnLearningSection from '@/components/RevampedLanding/HandsOnLearningSection'
import usePageType from '@/hooks/useLandingPageType'
import { eventTracker } from '@/lib/events/cjrEventTracker'
import { isFromApp } from '@/utils/utils'
import createWidget, { IPageDataContext } from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import { JSX, useState } from 'react'
import HandsOnLearningSectionSchema, {
  HandsOnLearningSectionDefaultValues,
  handsOnLearning
} from './schema'

export function HandsOnLearningSectionWidget(props: handsOnLearning & IPageDataContext) {
  const { handsOnLearningSection, pageData } = props

  const [isBookDemoModalOpen, setIsBookDemoModalOpen] = useState(false)

  const { currentPageType, fullPath } = usePageType()

  const handleOpenBookDemoModal = ({ clickFrom }: { clickFrom?: string }) => {
    eventTracker.bookADemoClick({
      clickFrom: clickFrom as 'sticky' | 'hero_section' | 'cohorts_section' | 'product_features_section',
      came_from: currentPageType,
      page_link: fullPath as string,
    })
    setIsBookDemoModalOpen(true)
  }

  return (
    <>
      <HandsOnLearningSection
        handsOnLearningData={handsOnLearningSection}
        handleOpenBookDemoModal={handleOpenBookDemoModal}
      />
      {isBookDemoModalOpen && (
        <BookDemoModal
          activeState='select_goal'
          open={isBookDemoModalOpen}
          onClose={() => setIsBookDemoModalOpen(false)}
          goals={pageData?.curiousJrLandingData?.data?.goalSection?.goals || []}
          isOtplessEnabled={pageData?.curiousJrLandingData?.data?.isOtplessEnabled}
          appRedirectionScreen={pageData?.curiousJrLandingData?.data?.appRedirectionScreen}
          shouldTriggerTruecaller={pageData?.curiousJrLandingData?.data?.shouldTriggerTruecaller || false}
          pageSource={isFromApp() ? 'APP' : 'LANDING'}
        />
      )}
    </>
  )
}

export default createWidget<handsOnLearning>({
  formType: HandsOnLearningSectionSchema,
  render(props, pageData): JSX.Element {
    return <HandsOnLearningSectionWidget {...props} pageData={pageData} />
  },
  id: 'Landing.Page.HandsOnLearningSection',
  name: 'Hands On Learning',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: HandsOnLearningSectionDefaultValues,
})
